import useNewC4Journey from 'hooks/useNewC4Journey';
import { checkoutType } from 'pages/Cart/helpers/url.helpers';
import { useMemo } from 'react';

const useShowShipments = () => {
  const isNewJourney = useNewC4Journey();
  const shipmentType = checkoutType();
  // for MKP we are not geting seller entries from getcart v3 api
  const availableShipment = useMemo(() => {
    if (!isNewJourney || shipmentType === 'DEFAULT') {
      return {
        QCOMM: true,
        QELEC: true,
        EXPRESS: true,
        NONFOOD: true,
        SLOTTED: true,
      };
    }

    const availableShipmentType: { [key: string]: boolean } = Object.seal({
      QCOMM: false,
      QELEC: false,
      EXPRESS: false,
      NONFOOD: false,
      SLOTTED: false,
    });
    if (shipmentType in availableShipmentType) {
      availableShipmentType[shipmentType] = true;
    }

    return availableShipmentType;
  }, [isNewJourney, shipmentType]);
  return availableShipment;
};

export default useShowShipments;
